var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
// icons
import newTag from "@frameworks/shared-library/assets/images/markets/newTag.svg";
import featuredTag from "@frameworks/shared-library/assets/images/features/Markets/Pms/focused.svg";
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import useDisabledCheck from "@frameworks/NCD/Hook/TabContent/useDisabledCheck";
import { ActionType } from "@domains/features/Markets/OTC/entities/BookMark";
import useBookmark from "@frameworks/NCD/Hook/TabContent/useBookmark";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useSelector } from "react-redux";
var getSchemeValue = function (schemeValuesArr, schemeKeysArr, schemeKey) {
    var _a;
    return (_a = schemeValuesArr[schemeKeysArr.indexOf(schemeKey)]) !== null && _a !== void 0 ? _a : "";
};
var defaultSchemeRenderer = function (keys) {
    var isNewScheme = getSchemeValue(keys, keys, keys === null || keys === void 0 ? void 0 : keys[3]);
    var isFeaturedScheme = getSchemeValue(keys, keys, keys === null || keys === void 0 ? void 0 : keys[2]);
    var generateWidthForCalc = function () {
        var maxWidth = 0;
        if (isFeaturedScheme) {
            maxWidth = 85;
        }
        if (isNewScheme) {
            maxWidth = 85;
        }
        if (isFeaturedScheme && isNewScheme) {
            maxWidth = 155;
        }
        return "calc(100% - ".concat(maxWidth, "px)");
    };
    return (React.createElement("div", { className: "d-flex align-item-center gap-2 otc-table-wrapper" },
        React.createElement("div", { style: { width: "auto" }, className: "read-more-tooltip align-items-center scheme_name_wrap" },
            React.createElement(GenericSchemeName, { name: capitalizeFirstLetter(keys[0]), subText1: keys[1], maxWidth: 300, maxWidthUnit: "px", showTooltip: true, showImage: true, parentClassName: "text-start", tooltipPlacement: "top", tooltipClassName: "scheme-name-tooltip", subTextMaxWidth: generateWidthForCalc(), textAndBackgroundColorCollectionConfig: alphabetsColorsConfigMap, highlightSchemeNameOnHover: true })),
        (isNewScheme || isFeaturedScheme) && (React.createElement("div", { className: "flex-column new-or-featured-tag-container" },
            isNewScheme && React.createElement("img", { src: newTag, alt: "New Scheme" }),
            isFeaturedScheme && React.createElement("img", { src: featuredTag, alt: "Featured Scheme" })))));
};
var useGenerateTableColumns = function (_a) {
    var _b, _c, _d;
    var id = _a.id, checked = _a.checked, handleCheck = _a.handleCheck, handleSelectAll = _a.handleSelectAll, handleTransactionClick = _a.handleTransactionClick, handleBookmark = _a.handleBookmark, _e = _a.customColumns, customColumns = _e === void 0 ? [] : _e, _f = _a.columnPositions, columnPositions = _f === void 0 ? {} : _f, customSchemeColumn = _a.customSchemeColumn, onClickShare = _a.onClickShare, isBookmarkFunctionality = _a.isBookmarkFunctionality, isSaveProduct = _a.isSaveProduct, allTabPage = _a.allTabPage;
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.LoginType);
    var subCategoryId = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).subCategoryId;
    var defaultColumns = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read((isBookmarkFunctionality
        ? [
            {
                columnName: (React.createElement("div", { className: "d-flex align-items-start justify-content-center fund-checkbox common-checkbox-custom small-checkbox ps-2" },
                    React.createElement("input", { type: "checkbox", onChange: handleSelectAll, checked: checked.length > 0 }))),
                keysForCustomFunction: ["isin_id"],
                tdCustomFunction: function (keys) {
                    return (React.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "fund-checkbox common-checkbox-custom small-checkbox ps-2" },
                        React.createElement("input", { value: keys === null || keys === void 0 ? void 0 : keys[0], type: "checkbox", name: keys === null || keys === void 0 ? void 0 : keys[0], onChange: handleCheck, checked: checked.findIndex(function (x) { return x.isin_id === (keys === null || keys === void 0 ? void 0 : keys[0]); }) > -1 })));
                },
                arrowClassName: "justify-content-start",
                columnClassName: "line-4 text-start",
            },
        ]
        : [])), false), [
        {
            columnName: (_b = customSchemeColumn === null || customSchemeColumn === void 0 ? void 0 : customSchemeColumn.columnName) !== null && _b !== void 0 ? _b : "NCD Name",
            keysForCustomFunction: (_c = customSchemeColumn === null || customSchemeColumn === void 0 ? void 0 : customSchemeColumn.keys) !== null && _c !== void 0 ? _c : [
                "display_name",
                "isin_code",
                "isfocused",
                "isnewly_added",
            ],
            arrows: true,
            type: "string",
            applySorting: true,
            sortKey: "display_name",
            tdCustomFunction: (_d = customSchemeColumn === null || customSchemeColumn === void 0 ? void 0 : customSchemeColumn.renderer) !== null && _d !== void 0 ? _d : defaultSchemeRenderer,
        }
    ], false), __read((isBookmarkFunctionality || isSaveProduct
        ? []
        : [
            {
                columnName: "Client Name",
                key: "",
                key3: "client_name",
                sortKey: "client_name",
                arrows: true,
                arrowClassName: "justify-content-start",
                columnClassName: "text-start DMSansMedium_12_500",
                applySorting: true,
                keysForCustomFunction: ["client_name", "pan"],
                tdCustomFunction: function (keys) {
                    var _a, _b;
                    return (React.createElement("div", { style: { cursor: "pointer" } },
                        React.createElement("span", { className: "txt-midnight-blue-shade2 client-name-wrapper DMSanN_14_400", title: keys[0] }, (_a = keys[0]) !== null && _a !== void 0 ? _a : "--"),
                        React.createElement("br", null),
                        React.createElement("span", { className: "txt-independence RobotoM_14_300" }, (_b = keys[1]) !== null && _b !== void 0 ? _b : "--")));
                },
            },
        ])), false), [
        {
            columnName: "Action",
            arrows: false,
            arrowClassName: "DMSansMedium_12_500 ".concat(subCategoryId === String(ESubProductIds.UnlistedShares)
                ? "justify-content-end"
                : "justify-content-center", " "),
            keysForCustomFunction: [
                "display_name",
                "isin_code",
                "rating",
                "interest_frequency",
                "price_range",
                "avl_qty",
                "coupon_rate",
                "isin_id",
                "min_sell_price",
                "trx_id",
                "min_sell_price",
                "max_sell_price",
                "max_price",
                "dirty_price_buy",
                "virtual_buy_qty",
                "buy_price_min",
                "buy_price_max",
                "price_range_buy",
                "category_code",
                "entity_name",
            ],
            columnClassName: "DMSansMedium_12_500 ".concat(subCategoryId === String(ESubProductIds.UnlistedShares)
                ? "text-center"
                : "text-start", " "),
            tdCustomFunction: function (keys) {
                var _a = useDisabledCheck(checked, keys), isDisabled = _a.isDisabled, disabledClass = _a.disabledClass;
                var bookmarkClass = useBookmark(Number(keys[7]), allTabPage, checked);
                return (React.createElement("div", { className: "d-flex align-items-center gap-10 table-row-action-container ".concat(subCategoryId === String(ESubProductIds.UnlistedShares) &&
                        "justify-content-end") },
                    React.createElement(EdButton, { btnTyp: "tomato-rounded", value: partnerCategory == ILoginTypeEnum.PARTNER
                            ? "Register Lead"
                            : "Place order", onClick: function (e) { return handleTransactionClick(keys, e); }, className: "invest-button text-nowrap DMsanL_15_300 mgr-22 width-126 height-32 ".concat(disabledClass, " me-0"), hoverType: "tomato-rounded-background", disabled: isDisabled }),
                    (isBookmarkFunctionality || isSaveProduct) && (React.createElement(React.Fragment, null,
                        React.createElement(EdButtonIcon, { btnIcon: bookmarkClass, btnTyp: "link", className: "bg-transparent share-btn txt_dull-grey ".concat(disabledClass), disabled: isDisabled, paths: 3, onClick: function (e) {
                                var options = {
                                    isMultiple: false,
                                    allTabPage: allTabPage,
                                };
                                e.stopPropagation();
                                handleBookmark([keys[7], keys[18]], bookmarkClass === "edel-icon-remove-bookmark"
                                    ? ActionType.DELETE
                                    : ActionType.INSERT, options);
                            } })))));
            },
        },
    ], false);
    var extractColumnKey = function (col) {
        var _a, _b, _c;
        if (typeof col.columnName === "string")
            return col.columnName.trim();
        if (React.isValidElement(col.columnName)) {
            var child = (_a = col.columnName.props) === null || _a === void 0 ? void 0 : _a.children;
            if (typeof child === "string")
                return child.trim();
            if (Array.isArray(child)) {
                return child
                    .map(function (c) { return (typeof c === "string" ? c : ""); })
                    .join("")
                    .trim();
            }
            return (_c = (_b = child === null || child === void 0 ? void 0 : child.toString) === null || _b === void 0 ? void 0 : _b.call(child).trim()) !== null && _c !== void 0 ? _c : "";
        }
        return "";
    };
    var checkboxColumn = defaultColumns.find(function (col) {
        return extractColumnKey(col).toLowerCase().includes("checkbox");
    });
    var actionColumn = defaultColumns.find(function (col) { return extractColumnKey(col) === "Action"; });
    var middleDefaults = defaultColumns.filter(function (col) { return col !== checkboxColumn && col !== actionColumn; });
    var combined = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read((checkboxColumn ? [checkboxColumn] : [])), false), __read(middleDefaults), false), __read(customColumns), false), __read((actionColumn ? [actionColumn] : [])), false);
    var sorted = combined.sort(function (a, b) {
        var _a, _b;
        var posA = (_a = columnPositions[extractColumnKey(a)]) !== null && _a !== void 0 ? _a : 100;
        var posB = (_b = columnPositions[extractColumnKey(b)]) !== null && _b !== void 0 ? _b : 100;
        return posA - posB;
    });
    return sorted;
};
export default useGenerateTableColumns;
